import { render } from "./DefautsComponent.vue?vue&type=template&id=d5d58842"
import script from "./DefautsComponent.vue?vue&type=script&lang=js"
export * from "./DefautsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__